exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".IPoE_component_3kKo {\n  font-family: Arial;\n  font-size: 13px;\n}\n\n.IPoE_links_8unR {\n  margin-top: 15px;\n}\n\n.IPoE_link_2pIK:not(:first-child) {\n  margin-left: 20px;\n}\n\n.IPoE_preloader_3meK {\n  position: static;\n  margin: 25px 0;\n\n  display: block;\n\n  text-align: left;\n\n  -webkit-transform: none;\n\n          transform: none;\n}\n\n.IPoE_status_1Hp0 {\n  margin-top: 20px;\n\n  max-width: none;\n\n  font-family: Arial;\n  font-size: 13px;\n  text-align: left;\n}\n", ""]);

// exports
exports.locals = {
	"component": "IPoE_component_3kKo",
	"links": "IPoE_links_8unR",
	"link": "IPoE_link_2pIK",
	"preloader": "IPoE_preloader_3meK",
	"status": "IPoE_status_1Hp0"
};